/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    EnergyConsumptionResponse,
    PowerConsumptionResponse,
    SessionCountResponse,
    TotalEnergyConsumptionResponse,
} from "../models/index";
import {
    EnergyConsumptionResponseFromJSON,
    EnergyConsumptionResponseToJSON,
    PowerConsumptionResponseFromJSON,
    PowerConsumptionResponseToJSON,
    SessionCountResponseFromJSON,
    SessionCountResponseToJSON,
    TotalEnergyConsumptionResponseFromJSON,
    TotalEnergyConsumptionResponseToJSON,
} from "../models/index";

export interface GetChargeSessionCountRequest {
    from: string;
    to: string;
    interval: GetChargeSessionCountIntervalEnum;
    deviceGroupTags?: Array<string>;
    deviceId?: string;
    inLocalTime?: boolean;
    asTrend?: boolean;
}

export interface GetCumulativeEnergyConsumptionRequest {
    from: string;
    to: string;
    interval: GetCumulativeEnergyConsumptionIntervalEnum;
    deviceId: string;
    inLocalTime?: boolean;
}

export interface GetPowerConsumptionRequest {
    from: string;
    to: string;
    deviceId: string;
    interval?: GetPowerConsumptionIntervalEnum;
    inLocalTime?: boolean;
}

export interface GetTotalEnergyConsumptionHistoryRequest {
    from: string;
    to: string;
    interval: GetTotalEnergyConsumptionHistoryIntervalEnum;
    deviceGroupTag: string;
    inLocalTime?: boolean;
}

export interface GetTotalEnergyConsumptionValueRequest {
    from: string;
    to: string;
    deviceGroupTags?: Array<string>;
    inLocalTime?: boolean;
    isIntersection?: boolean;
}

/**
 *
 */
export class ConsumptionDashboardHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Get the count of charge sessions that started in a time period, aggregated by the requested interval, for the requested device (either a specific charger or power meter id, or use the core deviceId for all chargers assigned to the core, or deviceGroupTag for the whole site, or omit for ALL devices). Requires device_energy_usage_read permission if deviceGroupTag or deviceId are provided, or global_dashboard permission if not provided. Don\'t provide both.
     */
    async getChargeSessionCountRaw(
        requestParameters: GetChargeSessionCountRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<SessionCountResponse>> {
        if (requestParameters["from"] == null) {
            throw new runtime.RequiredError(
                "from",
                'Required parameter "from" was null or undefined when calling getChargeSessionCount().',
            );
        }

        if (requestParameters["to"] == null) {
            throw new runtime.RequiredError(
                "to",
                'Required parameter "to" was null or undefined when calling getChargeSessionCount().',
            );
        }

        if (requestParameters["interval"] == null) {
            throw new runtime.RequiredError(
                "interval",
                'Required parameter "interval" was null or undefined when calling getChargeSessionCount().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["interval"] != null) {
            queryParameters["interval"] = requestParameters["interval"];
        }

        if (requestParameters["deviceGroupTags"] != null) {
            queryParameters["deviceGroupTags"] = requestParameters[
                "deviceGroupTags"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters["deviceId"] != null) {
            queryParameters["deviceId"] = requestParameters["deviceId"];
        }

        if (requestParameters["inLocalTime"] != null) {
            queryParameters["inLocalTime"] = requestParameters["inLocalTime"];
        }

        if (requestParameters["asTrend"] != null) {
            queryParameters["asTrend"] = requestParameters["asTrend"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/consumption-dashboard/charge-session-count`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            SessionCountResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get the count of charge sessions that started in a time period, aggregated by the requested interval, for the requested device (either a specific charger or power meter id, or use the core deviceId for all chargers assigned to the core, or deviceGroupTag for the whole site, or omit for ALL devices). Requires device_energy_usage_read permission if deviceGroupTag or deviceId are provided, or global_dashboard permission if not provided. Don\'t provide both.
     */
    async getChargeSessionCount(
        requestParameters: GetChargeSessionCountRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<SessionCountResponse> {
        const response = await this.getChargeSessionCountRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get Cumulative energy consumption history in Wh for a time period, aggregated by the requested interval, for the requested device (either a specific charger or power meter id, or use the core id for the whole site).
     */
    async getCumulativeEnergyConsumptionRaw(
        requestParameters: GetCumulativeEnergyConsumptionRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<EnergyConsumptionResponse>> {
        if (requestParameters["from"] == null) {
            throw new runtime.RequiredError(
                "from",
                'Required parameter "from" was null or undefined when calling getCumulativeEnergyConsumption().',
            );
        }

        if (requestParameters["to"] == null) {
            throw new runtime.RequiredError(
                "to",
                'Required parameter "to" was null or undefined when calling getCumulativeEnergyConsumption().',
            );
        }

        if (requestParameters["interval"] == null) {
            throw new runtime.RequiredError(
                "interval",
                'Required parameter "interval" was null or undefined when calling getCumulativeEnergyConsumption().',
            );
        }

        if (requestParameters["deviceId"] == null) {
            throw new runtime.RequiredError(
                "deviceId",
                'Required parameter "deviceId" was null or undefined when calling getCumulativeEnergyConsumption().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["interval"] != null) {
            queryParameters["interval"] = requestParameters["interval"];
        }

        if (requestParameters["deviceId"] != null) {
            queryParameters["deviceId"] = requestParameters["deviceId"];
        }

        if (requestParameters["inLocalTime"] != null) {
            queryParameters["inLocalTime"] = requestParameters["inLocalTime"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/consumption-dashboard/cumulative-energy`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            EnergyConsumptionResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get Cumulative energy consumption history in Wh for a time period, aggregated by the requested interval, for the requested device (either a specific charger or power meter id, or use the core id for the whole site).
     */
    async getCumulativeEnergyConsumption(
        requestParameters: GetCumulativeEnergyConsumptionRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<EnergyConsumptionResponse> {
        const response = await this.getCumulativeEnergyConsumptionRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get power consumption (Amps, Watts, Volts, Var, Wh) for a time period, averaged over the requested interval, for the requested device (either a specific power meter id, or use the core id for the whole site).
     */
    async getPowerConsumptionRaw(
        requestParameters: GetPowerConsumptionRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<PowerConsumptionResponse>>> {
        if (requestParameters["from"] == null) {
            throw new runtime.RequiredError(
                "from",
                'Required parameter "from" was null or undefined when calling getPowerConsumption().',
            );
        }

        if (requestParameters["to"] == null) {
            throw new runtime.RequiredError(
                "to",
                'Required parameter "to" was null or undefined when calling getPowerConsumption().',
            );
        }

        if (requestParameters["deviceId"] == null) {
            throw new runtime.RequiredError(
                "deviceId",
                'Required parameter "deviceId" was null or undefined when calling getPowerConsumption().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["interval"] != null) {
            queryParameters["interval"] = requestParameters["interval"];
        }

        if (requestParameters["deviceId"] != null) {
            queryParameters["deviceId"] = requestParameters["deviceId"];
        }

        if (requestParameters["inLocalTime"] != null) {
            queryParameters["inLocalTime"] = requestParameters["inLocalTime"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/consumption-dashboard/power`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(PowerConsumptionResponseFromJSON),
        );
    }

    /**
     * Get power consumption (Amps, Watts, Volts, Var, Wh) for a time period, averaged over the requested interval, for the requested device (either a specific power meter id, or use the core id for the whole site).
     */
    async getPowerConsumption(
        requestParameters: GetPowerConsumptionRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<PowerConsumptionResponse>> {
        const response = await this.getPowerConsumptionRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get energy consumption history in Wh for a time period, for the requested device group, aggregated over the requested interval. Result is one value per interval, representing the total consumption of all devices in the group in that time. Data is pre-calculated on a hourly schedule. Currently, only StatInterval.Hour is supported.
     */
    async getTotalEnergyConsumptionHistoryRaw(
        requestParameters: GetTotalEnergyConsumptionHistoryRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<EnergyConsumptionResponse>> {
        if (requestParameters["from"] == null) {
            throw new runtime.RequiredError(
                "from",
                'Required parameter "from" was null or undefined when calling getTotalEnergyConsumptionHistory().',
            );
        }

        if (requestParameters["to"] == null) {
            throw new runtime.RequiredError(
                "to",
                'Required parameter "to" was null or undefined when calling getTotalEnergyConsumptionHistory().',
            );
        }

        if (requestParameters["interval"] == null) {
            throw new runtime.RequiredError(
                "interval",
                'Required parameter "interval" was null or undefined when calling getTotalEnergyConsumptionHistory().',
            );
        }

        if (requestParameters["deviceGroupTag"] == null) {
            throw new runtime.RequiredError(
                "deviceGroupTag",
                'Required parameter "deviceGroupTag" was null or undefined when calling getTotalEnergyConsumptionHistory().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["interval"] != null) {
            queryParameters["interval"] = requestParameters["interval"];
        }

        if (requestParameters["deviceGroupTag"] != null) {
            queryParameters["deviceGroupTag"] =
                requestParameters["deviceGroupTag"];
        }

        if (requestParameters["inLocalTime"] != null) {
            queryParameters["inLocalTime"] = requestParameters["inLocalTime"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/consumption-dashboard/total-energy-history-cached`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            EnergyConsumptionResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get energy consumption history in Wh for a time period, for the requested device group, aggregated over the requested interval. Result is one value per interval, representing the total consumption of all devices in the group in that time. Data is pre-calculated on a hourly schedule. Currently, only StatInterval.Hour is supported.
     */
    async getTotalEnergyConsumptionHistory(
        requestParameters: GetTotalEnergyConsumptionHistoryRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<EnergyConsumptionResponse> {
        const response = await this.getTotalEnergyConsumptionHistoryRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get Total energy consumption value in Wh for a time period, for the requested device groups. Consumption is returned as a single value per charger (except when requesting the *global* total), and as a total figure. Also includes percentage diff with the immediately preceding period.
     */
    async getTotalEnergyConsumptionValueRaw(
        requestParameters: GetTotalEnergyConsumptionValueRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<TotalEnergyConsumptionResponse>> {
        if (requestParameters["from"] == null) {
            throw new runtime.RequiredError(
                "from",
                'Required parameter "from" was null or undefined when calling getTotalEnergyConsumptionValue().',
            );
        }

        if (requestParameters["to"] == null) {
            throw new runtime.RequiredError(
                "to",
                'Required parameter "to" was null or undefined when calling getTotalEnergyConsumptionValue().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["deviceGroupTags"] != null) {
            queryParameters["deviceGroupTags"] = requestParameters[
                "deviceGroupTags"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters["inLocalTime"] != null) {
            queryParameters["inLocalTime"] = requestParameters["inLocalTime"];
        }

        if (requestParameters["isIntersection"] != null) {
            queryParameters["isIntersection"] =
                requestParameters["isIntersection"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/consumption-dashboard/total-energy-value`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            TotalEnergyConsumptionResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get Total energy consumption value in Wh for a time period, for the requested device groups. Consumption is returned as a single value per charger (except when requesting the *global* total), and as a total figure. Also includes percentage diff with the immediately preceding period.
     */
    async getTotalEnergyConsumptionValue(
        requestParameters: GetTotalEnergyConsumptionValueRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<TotalEnergyConsumptionResponse> {
        const response = await this.getTotalEnergyConsumptionValueRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}

/**
 * @export
 */
export const GetChargeSessionCountIntervalEnum = {
    Minute: "minute",
    Hour: "hour",
    Day: "day",
    Week: "week",
    Month: "month",
} as const;
export type GetChargeSessionCountIntervalEnum =
    (typeof GetChargeSessionCountIntervalEnum)[keyof typeof GetChargeSessionCountIntervalEnum];
/**
 * @export
 */
export const GetCumulativeEnergyConsumptionIntervalEnum = {
    Minute: "minute",
    Hour: "hour",
    Day: "day",
    Week: "week",
    Month: "month",
} as const;
export type GetCumulativeEnergyConsumptionIntervalEnum =
    (typeof GetCumulativeEnergyConsumptionIntervalEnum)[keyof typeof GetCumulativeEnergyConsumptionIntervalEnum];
/**
 * @export
 */
export const GetPowerConsumptionIntervalEnum = {
    Minute: "minute",
    Hour: "hour",
    Day: "day",
    Week: "week",
    Month: "month",
} as const;
export type GetPowerConsumptionIntervalEnum =
    (typeof GetPowerConsumptionIntervalEnum)[keyof typeof GetPowerConsumptionIntervalEnum];
/**
 * @export
 */
export const GetTotalEnergyConsumptionHistoryIntervalEnum = {
    Minute: "minute",
    Hour: "hour",
    Day: "day",
    Week: "week",
    Month: "month",
} as const;
export type GetTotalEnergyConsumptionHistoryIntervalEnum =
    (typeof GetTotalEnergyConsumptionHistoryIntervalEnum)[keyof typeof GetTotalEnergyConsumptionHistoryIntervalEnum];
